import CandidateNoteSpecialFields, {
  CandidateNoteSpecialFieldsProps,
} from './CandidateNoteSpecialFields.container';

export type CandidateNoteSpecialFieldsType = CandidateNoteSpecialFieldsProps;

export default CandidateNoteSpecialFields;
